import classNames from 'classnames'
import isNumber from 'lodash/isNumber'
import React, { FC, memo } from 'react'
import { Column } from '../../../models/column'
import { makeStyles } from '@material-ui/core'
import { productConfiguration } from '@stores/productConfigurationStore'

const useStyles = makeStyles(theme => ({
  rowCell: {
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 9
  },
  stickyCell: {
    position: 'sticky',
    boxShadow: 'rgb(133 146 166 / 20%) 3px 0px 5px -3px',
    zIndex: 10
  },
  enhancedSticky: {
    borderRight: '2px solid #ccc !important'
  },
  enhancedCellBorder: {
    borderRight: '1px solid #ccc'
  },
  enhancedRowCellBorder: {
    borderRight: '1px solid #ccc'
  },
  cellBorder: {
    borderRight: '1px solid #ededed'
  },
  enhancedStickyHeader: {
    borderRight: '2px solid #ccc !important',
    boxShadow: 'none'
  }
}))

export interface CellProps {
  column: Column
  id: string
  rowData: any
  stickyPosition: number
  offset: number
  visibleColIndex: number
  isActive: boolean
  enhancedViewCell?: boolean
  isHierarchyCell?: boolean
}

export interface CellItem extends CellProps {
  cellData: any
}

const Cell: FC<CellProps> = ({
  column,
  id,
  rowData,
  stickyPosition,
  visibleColIndex,
  isActive,
  enhancedViewCell
}) => {
  const classes = useStyles()
  const {
    field,
    cellElement: CellElement,
    width,
    showBorders = false,
    key,
    isStickyBorder = false,
    ...extraProps
  } = column
  const { enhancedViewEnabled } = productConfiguration
  return (
    <div
      className={classNames(classes.rowCell, {
        [classes.stickyCell]: isNumber(stickyPosition),
        [classes.cellBorder]:
          !enhancedViewCell && !enhancedViewEnabled && !isStickyBorder && showBorders,
        [classes.enhancedSticky]: enhancedViewCell && key && isNumber(stickyPosition),
        [classes.enhancedCellBorder]: enhancedViewCell && !key && showBorders,
        [classes.enhancedStickyHeader]: isStickyBorder,
        [classes.enhancedRowCellBorder]:
          enhancedViewEnabled && !enhancedViewCell && showBorders
      })}
      style={{
        width: width || '100%',
        minWidth: width,
        left: stickyPosition
      }}
    >
      {CellElement ? (
        <CellElement
          column={column}
          id={id}
          rowData={rowData}
          cellData={rowData?.[field]}
          visibleColIndex={visibleColIndex}
          isActive={isActive}
          {...extraProps}
        />
      ) : (
        rowData?.[field]
      )}
    </div>
  )
}

export default memo(Cell)
